import React from 'react'
import { ThemeProvider } from '@deseretbook/react-ui'
import Benefit from './Benefit'

const BenefitsPage = ({ description, imageProps }) => (
  <ThemeProvider>
    <div />
  </ThemeProvider>
)

export default BenefitsPage
